
import React, { Component } from 'react';

import './../../../scss/App.scss';
import { AD_MORE_TIME_CLICKED } from '../../utils/constants';
import { trackingWrapper } from '../../utils/analytics';

const NAMESPACE = '[ VideoOverlay ]';
export const RANDOM_END_RESULT_VIDEOS = 1;

class VideoOverlay extends Component {

	constructor(props){
		super(props);

		this.skipBtnAfterSecs = window.config.videoAd.skipBtnAppearsAfterSecs;
		this.skipAdCountdownLabel = window.config.videoAd.skipAdCountdownLabel;

		this.timer = null;

		this.state = {
			videoId : props.videoId || null,
			timerRemaining : this.skipBtnAfterSecs
		}

		// Tracking flags
		this.tracked10Played = false;
		// this.tracked25Played = false;
		this.tracked50Played = false;
		// this.tracked75Played = false;
		this.tracked90Played = false;
		// this.trackedPlayed = false;
		
		this.handleMediaStartedRef = this.handleMediaStarted.bind(this);
		this.handleMediaPlayingRef = this.handleMediaPlaying.bind(this);
		this.handleMediaEndedRef = this.handleMediaEnded.bind(this);
		this.handleIFrameLoaded = this.handleIFrameLoaded.bind(this);
		this.handleCloseBtnClick = this.handleCloseBtnClick.bind(this);
		this.timerTick = this.timerTick.bind(this);
	}

	componentWillMount(){
		if (this.state.videoId === null) {
			this.setRandomVideo();
		} else {
			this.setVideo(this.state.videoId);
		}

		// tracking
		let trackingTag = 'ASgame-2nd-replay-gate-ad';
		if (this.props.showVideoAd === AD_MORE_TIME_CLICKED){
			trackingTag = 'ASgame-more-time-ad';
		}	
		trackingWrapper('event', trackingTag, {'event_category':'america-says-game'});
	}

	componentDidMount(){
		window.TweenMax.set(this.refs.closeBtn, {"display":"none", "opacity":0});
		window.TweenMax.set(this.refs.skipCountdown, {"opacity":0});

		this.timer = setInterval(this.timerTick, 1000);

		// begin fade in of countdown
		window.TweenMax.to(this.refs.skipCountdown, (this.skipBtnAfterSecs + 2), {"opacity":1});
	}

	timerTick(){
		const newTime = this.state.timerRemaining - 1;

		if(newTime < 1){
			clearInterval(this.timer);

			// hide countdown, show close button
			window.TweenMax.set(this.refs.skipCountdown, {"display":"none"});
			window.TweenMax.set(this.refs.closeBtn, {"display":"block"});

			window.TweenMax.to(this.refs.closeBtn, .4, {"opacity":1});
		}
		else{
			// update timer
			this.setState({
				timerRemaining : newTime
			});
		}

	}

	setRandomVideo(){

		//console.log("================ VideoOverlay :: setRandomVideo() - start pool:", window.videoAdsPool);

		// get random from pool
		let video = window.videoAdsPool[Math.floor(Math.random() * window.videoAdsPool.length)];

		// remove chosen from pool
		const newVideoAdsPool = [...window.videoAdsPool.filter(x => x !== video)];

		// if pool is empty, reset the pool with full list minus selected
		if(newVideoAdsPool.length === 0){
			window.videoAdsPool = [...window.config.videoAd.videos];

			// if total pool size is > 1, remove the selected so it does show back to back on next cycle
			if(window.config.videoAd.videos.length > 1){
				window.videoAdsPool = [...window.videoAdsPool.filter(x => x !== video)];
			}
		}
		else {
			window.videoAdsPool = [...newVideoAdsPool];
		}

		//console.log("VideoOverlay :: setRandomVideo() -  selected video: ", video);
		//console.log("VideoOverlay :: setRandomVideo() -  end pool: ", window.videoAdsPool);

		this.setVideo(video);
	}

	setVideo(id) {
		this.setState({
			videoId : id
		});
	}

	handleIFrameLoaded() {
		console.log( NAMESPACE, 'handleIFrameLoaded()' );
		window.$pdk.bind(this, true);
		window.$pdk.controller.setIFrame(this.refs.iframe, true);
		
		window.$pdk.controller.addEventListener( 'OnMediaStart', this.handleMediaStartedRef );
		window.$pdk.controller.addEventListener( 'OnMediaPlaying', this.handleMediaPlayingRef );
		window.$pdk.controller.addEventListener( 'OnMediaEnd', this.handleMediaEndedRef );
	}
	
	handleMediaStarted() {
		
		console.log( NAMESPACE, 'handleMediaStarted()' );
		
	}
	
	handleMediaPlaying( event ) {
		// console.log( NAMESPACE, 'media playing ', 'time: '+event.data.currentTime, ' duration: '+event.data.duration );
		
		let percentage = event.data.currentTime / event.data.duration;
		
		if( percentage > 0.9 && !this.tracked90Played ) {
			// console.log( NAMESPACE, 'track 90% played' );
			// trackingWrapper('event', 'ASgame-ad-play-90%', {'event_category':'america-says-game'});
			this.tracked90Played = true;
		} 
		else if( percentage > 0.5 && !this.tracked50Played ) {
			// console.log( NAMESPACE, 'track 50% played' );
			// trackingWrapper('event', 'ASgame-ad-play-50%', {'event_category':'america-says-game'});
			this.tracked50Played = true;
		}
		else if( percentage > 0.1 && !this.tracked10Played ) {
			// console.log( NAMESPACE, 'track 10% played' );
			// trackingWrapper('event', 'ASgame-ad-play-10%', {'event_category':'america-says-game'});
			this.tracked10Played = true;
		}
	}
	
	handleMediaEnded() {
		console.log( NAMESPACE, 'handleMediaEnded()' );
		
		this.closeOverlay();
	}

	handleCloseBtnClick(){

		// tracking
		trackingWrapper('event', 'ASgame-skip-ad', {'event_category':'america-says-game'});

		this.closeOverlay();
	}

	closeOverlay(){
		this.props.handleVideoOverlayClose();
	}
	
	componentWillUnmount() {
		console.log( NAMESPACE, 'componentWillUnmount()' );
		
		window.$pdk.controller.removeEventListener( 'OnMediaStart', this.handleMediaStartedRef );
		window.$pdk.controller.removeEventListener( 'OnMediaPlaying', this.handleMediaPlayingRef );
		window.$pdk.controller.removeEventListener( 'OnMediaEnd', this.handleMediaEndedRef );
		
		window.$pdk.controller.resetPlayer();
	}

	render(){
		const iframeUrl = "https://player.theplatform.com/p/" + window.config.mpx.clientId + "/" + window.config.mpx.playerId + "/embed/select/media/" + this.state.videoId + "?form=html&autoPlay=true";

		// countdown
		const countDownText = "" + this.skipAdCountdownLabel + " " + this.state.timerRemaining;

		return(
			<div id="videoOverlay">
				<div className="text">America Says Game Will Resume After This Video</div>
				<div className="video-player">
					<iframe ref='iframe' src={iframeUrl} width="100%" height="100%" scrolling="no" frameBorder="0" seamless="seamless" title="MPX Player" allowFullScreen onLoad={this.handleIFrameLoaded}></iframe>
				</div>
				<div className="skipCountdown" ref="skipCountdown">{countDownText}</div>
				<div className="closeBtn" ref="closeBtn" onClick={() => this.handleCloseBtnClick()}>x</div>
			</div>
		);
	}
}

export default VideoOverlay;


// WEBPACK FOOTER //
// ./src/js/components/ads/VideoOverlay.js